import { domainHighlightTpl } from '../domainHighlight/domainHighlightTpl';

export const aroundYouTab = {
  selectors: {
    tabsSelector: '.js-tabs'
  },

  initOrRefresh: options => {
    options = typeof options === 'object' ? options : {};
    const $document = $(document);
    const aroundUserTabSelector = `${options.mainSelector} ${aroundYouTab.selectors.tabsSelector} [data-tabcode="AROUND_USER"]`;
    const $aroundUserTab = $(aroundUserTabSelector);

    // Check if browsers supports geolocation and if user hasn't already refused it
    const geoLocDisabled = typeof navigator.geolocation === 'undefined' || cookieManagement.getCookie('userDenyLocation') === 'true';

    // Try to get user location stored in cookie if it exists
    const userLocationCookie = cookieManagement.getCookie('userLocation');
    const userPosition = geoLocDisabled ? false : (userLocationCookie === null ? false : JSON.parse(userLocationCookie));

    // Determine what tab we should show to the user
    const tabToShow = options.showTab ? (typeof options.forceTabToShow === 'string' ? options.forceTabToShow : (userPosition && !geoLocDisabled ? 'AROUND_USER' : typeof options.tabToShowInCaseOfFailure === 'string' ? options.tabToShowInCaseOfFailure : '')) : '';

    // Init listener for refresh crossSell event
    if (typeof options.refreshGeolocEventName === 'string') {
      dispatcher.stopListening(dispatcher, options.refreshGeolocEventName).listenTo(dispatcher, options.refreshGeolocEventName, searchModel => {
        aroundYouTab.initOrRefresh($.extend({}, options, {
          search_mainEngineModel: searchModel,
          forceTabToShow: $(`${options.mainSelector} ${aroundYouTab.selectors.tabsSelector} .visible`).data('tabcode')
        }));
      });
    }

    // Geolocation non supportée ou non autorisée ? Désactiver ou activer l'onglet "Autour de moi" visuellement en fonction grâce à "disabled"
    // "disableTabListener" permet d'empêcher le click listener du composant tabs de se faire tant que l'utilisateur n'a pas autorisé à donner sa position
    // Empéchant ainsi l'affichage du contenu de l'onglet "Autour de moi" tant qu'on n'a pas autorisé la position.
    $aroundUserTab.toggleClass('disabled', geoLocDisabled).toggleClass('disableTabListener', !geoLocDisabled && !userPosition);

    // Reset click listener on tabs if already set by a previous initOrRefresh() call
    const event_user = 'click.AROUND_USER';
    $document.off(event_user, aroundUserTabSelector);

    if (!geoLocDisabled && !userPosition) {
      // Init click listener on AROUND_USER tab to ask user location before load & display datas
      $document.on(event_user, aroundUserTabSelector, () => {
        geoloc.init(() => {
          // L'utilisateur a autorisé : on relance initOrRefresh() à nouveau
          aroundYouTab.initOrRefresh($.extend({}, options, {
            forceTabToShow: 'AROUND_USER',
            showTab: true
          }));
          // Handling distance button and labels
          geoloc.distance.showDistanceLabel();
          geoloc.distance.refresh();
        }, () => {
          // L'utilisateur a refusé : on affiche la tooltip par-dessus l'onglet "Autour de moi"
          aroundYouTab.showTooltipAndDisableTab($aroundUserTab);
        });
      });
    } else if (!userPosition) {
      // La geoloc a déjà été refusée ou n'est pas supportée par le navigateur : au clic sur l'onglet on affiche la tooltip par-dessus l'onglet "Autour de moi"
      $document.on(event_user, aroundUserTabSelector, () => {
        aroundYouTab.showTooltipAndDisableTab($aroundUserTab);
      });
    }

    if (tabToShow === '' || (tabToShow === 'AROUND_USER' && (geoLocDisabled || !userPosition))) {
      return;
    }

    const $tabToShowContentWrapper = $('.td-elems[data-tabcode="' + tabToShow + '"]').length ? $('.td-elems[data-tabcode="' + tabToShow + '"]') : $('.cs-elems[data-tabcode="' + tabToShow + '"]');

    // Proceed to ajax call and html generation only when search_mainEngineModel has been sent or if placeholder still visible
    if ((typeof options.search_mainEngineModel === 'object' || $tabToShowContentWrapper.find('.cs-placeholder').length)) {
      const $tabToShow = $(`${options.mainSelector} ${aroundYouTab.selectors.tabsSelector} [data-tabcode="${tabToShow}"]`);
      const nb_adults = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED;
      const nb_seniors = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED;
      const nb_pets = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED;
      const ages = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED;

      let dateUser = 1;

      if (GLOBAL_SCRIPTS.ABTEST_FLEX_PERIOD === 'B') {
        const storedSearchParams = JSON.parse(cookieManagement.getCookie('storedSearchParams')) || {};
        const hasStoredSearchParams = !!(Object.keys(storedSearchParams).length);

        if ((hasStoredSearchParams && typeof storedSearchParams.isFlexPeriod !== 'undefined' && storedSearchParams.isFlexPeriod) || window.location.search.indexOf('option[flexholiday]') !== -1) {
          dateUser = 0;
        }
      }

      const ajaxParams = {
        language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
        market: GLOBAL_SCRIPTS.MARKET_CODE,
        univers: GLOBAL_SCRIPTS.UNIVERS,
        page: 1,
        token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
        dateuser: dateUser,
        currency: GLOBAL_SCRIPTS.CURRENCY_CODE,
        accreditation: GLOBAL_SCRIPTS.ACCREDITATION,
        accreditationGroup: GLOBAL_SCRIPTS.ACCREDITATION_GROUP,
        cacheuser: GLOBAL_SCRIPTS.CACHE_USER,
        'option[formats_results]': '500x375',
        'facet[MULTIPARTICIPANTS][0][adult]': nb_adults,
        'facet[MULTIPARTICIPANTS][0][senior]': nb_seniors,
        'facet[MULTIPARTICIPANTS][0][pet]': nb_pets,
        'facet[MULTIPARTICIPANTS][0][ages]': ages
      };

      if (!geoLocDisabled && userPosition && tabToShow === 'AROUND_USER') {
        ajaxParams['geo[lat]'] = userPosition.lat;
        ajaxParams['geo[lon]'] = userPosition.long;
      }

      if (typeof options.additionnalAjaxParams === 'object') {
        $.extend(ajaxParams, options.additionnalAjaxParams);
      }

      const $searchArrivalInput = $('.js-search-arrivalInput');
      if ($searchArrivalInput.length) {
        ajaxParams['facet[DATE]'] = SEARCH_SCRIPTS.DATE_SELECTED;
      }

      const $searchDepartureInput = $('.js-search-departureInput');
      if ($searchDepartureInput.length) {
        ajaxParams['facet[DATEEND]'] = SEARCH_SCRIPTS.DATE_END_SELECTED;
      }

      if (typeof options.tabToShowInCaseOfFailure === 'string' && typeof options.additionnalAjaxParamsInCaseOfGeolocFailure === 'object' && tabToShow === options.tabToShowInCaseOfFailure) {
        $.extend(ajaxParams, options.additionnalAjaxParamsInCaseOfGeolocFailure);
      }

      $tabToShow.addClass('loading disableTabListener');

      genericAjaxCall({
        ajaxUrl: GLOBAL_SCRIPTS.URL_BASE_API + 'crosssell',
        origin: options.originId + tabToShow,
        ajaxParams: ajaxParams,
        successCallback: callbackDatas => {
          let newHtml = '';
          if (callbackDatas && callbackDatas.status === 'success') {
            if (Object.keys(callbackDatas.results.results).length) {
              newHtml = '';
              $.each(callbackDatas.results.results, (index, product) => {
                newHtml += domainHighlightTpl({
                  blockClass: 'gb-list--item swiper-slide',
                  product_datas: product,
                  labelNew: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_new,
                  labelRenovated: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_renovated,
                  early_booking_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.early_booking_label,
                  last_minute_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.last_minute_label,
                  totalParticipants: typeof options.search_mainEngineModel === 'object' ? options.search_mainEngineModel.get('totalParticipants') : nb_adults + nb_seniors + ages.length,
                  participants: {
                    children: ages.length,
                    senior: nb_seniors,
                    adult: nb_adults,
                    pet: nb_pets
                  }
                });
              });

              dispatcher.trigger('lazyload:update');

              Tracking.dataLayerPush({
                event: 'view_item_list',
                sub_event: 'view_accommodations',
                multicottage: 'no',
                ecommerce: {
                  items: Tracking.generateAccommodationsDatas({
                    datas: Object.entries(callbackDatas.results.results).map(result => {
                      result[1].additionnal_item_infos = {
                        item_adults_number: nb_adults,
                        item_seniors_number: nb_seniors,
                        item_children_number: ages.length,
                        item_number_person: nb_adults + nb_seniors + ages.length,
                        item_pets_number: nb_pets,
                        item_children_age: JSON.stringify(ages),
                        item_start_date: result[1].cache.date,
                        item_end_date: result[1].cache.dateEnd,
                        item_start_day_of_week: new Date(result[1].cache.date).toLocaleDateString(undefined, {
                          weekday: 'long'
                        }).replace(/\./gi, ''),
                        item_length_of_stay: genericDate.diff(new Date(result[1].cache.date), new Date(result[1].cache.dateEnd))
                      };

                      return result[1];
                    })
                  })
                }
              });
            }
          }

          $tabToShowContentWrapper.toggleClass('gb-simpleTxt', newHtml === '');

          // Set html content
          if (newHtml === '') {
            newHtml = GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.error_msg;
          }

          $tabToShowContentWrapper.find('.swiper-wrapper').html(newHtml);

          // Set active tab
          $tabToShow.removeClass('loading disableTabListener');
          dispatcher.trigger('tabs:setActiveTab', $tabToShow, false);
          dispatcher.trigger('lazyload:update');
        },
        abortable: true,
        type: 'GET',
        dataType: 'json'
      });
    }
  },

  showTooltipAndDisableTab: $tab => {
    $tab.addClass('disabled disableTabListener');
    dispatcher.trigger('tabs:tooltip:show', $tab, {
      id: 'geolocation',
      txt: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.geoloc_tooltip
    });
  }
};